import { AutoComplete, DropDownList } from "@progress/kendo-react-dropdowns";
import { TextBox } from "@progress/kendo-react-inputs";
import React from "react";
import { statusConfig } from "./configData";
import "./campaign.css";

export const Filter = (props) => {

  console.log(props.campaign_category_list);

  return (
    <div className="campaigns_filter_main_box">
      <div className="campaigns_filter_child_box">
        <div className="campaigns_filter_title">Campaign Name</div>
        <div className="campaigns_filter_textBox">
          <TextBox
            placeholder="Please input"
            value={props.filterData.name}
            onChange={(e) =>
              props.setFilterData({
                ...props.filterData,
                name: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="campaigns_filter_child_box">
        <div className="campaigns_filter_title">Campaign Category</div>
        <div className="campaigns_filter_dropdown">
          <DropDownList
            size={"large"}
            dataItemKey="name"
            textField="name"
            data={props.campaign_category_list}
            className="campaigns_filter_dropdown_item"
            value={props.campaign_category_list.find(item => item.name === props.filterData.category) || null}
            onChange={(e) =>
              props.setFilterData({
                ...props.filterData,
                category: e.target.value.name,
              })
            }
          />
        </div>
      </div>
      <div className="campaigns_filter_child_box">
        <div className="campaigns_filter_title">Reward Type</div>
        <div className="campaigns_filter_dropdown">
          <DropDownList
            size={"large"}
            data={props.reward_type_list}
            dataItemKey="name"
            textField="name"
            className="campaigns_filter_dropdown_item"
            value={props.reward_type_list.find(item => item.name === props.filterData.reward_type) || null}
            onChange={(e) =>
              props.setFilterData({
                ...props.filterData,
                reward_type: e.target.value.name,
              })
            }
          />
        </div>
      </div>
      <div className="campaigns_filter_child_box">
        <div className="campaigns_filter_title">Reward Provider</div>
        <div className="campaigns_filter_dropdown">
          <DropDownList
            size={"large"}
            data={props.reward_provider_list}
            dataItemKey="pk"
            textField="name"
            className="campaigns_filter_dropdown_item"
            value={props.reward_provider_list.find(item => item.pk === props.filterData.provider_id) || null}
            onChange={(e) =>
              props.setFilterData({
                ...props.filterData,
                provider: e.target.value.name,
                provider_id: e.target.value.pk,
              })
            }
          />
        </div>
      </div>
      <div className="campaigns_filter_child_box">
        <div className="campaigns_filter_title">Status</div>
        <div className="campaigns_filter_dropdown">
          <DropDownList
            size={"large"}
            data={statusConfig}
            dataItemKey="name"
            textField="name"
            className="campaigns_filter_dropdown_item"
            value={statusConfig.find(item => item.id === props.filterData.status) || null}
            onChange={(e) =>
              props.setFilterData({
                ...props.filterData,
                status: e.target.value.name,
              })
            }
          />
        </div>
      </div>
      <div className="campaigns_filter_child_box" style={{ gap: "8px", maxWidth: "110px", marginTop: "20px" }}>
        <div
          className="campaigns_filter_clear_button"
          onClick={() => {
            props.setFilterData({
              ...props.filterData,
              name: "",
              status: "",
              provider_id: "",
              provider: "",
              reward_type: "",
              category: "",
            });
            props.clearFilter();
          }
          }
        >
          Clear Filter
        </div>
        {/* <div
          className="campaigns_filter_approve_button"
          onClick={() => props.handleChangeStatus()}
        >
          Change Status
        </div> */}
      </div>
    </div>
  );
};
